<template>
    <Icon class="delete-icon-wrapper" :width="23" :height="19" @iconClick="iconClick" />
</template>

<script>
import Icon from './Icon'

export default {
    name: "DeleteIcon",
    components: {
        Icon,
    },
    methods: {
        iconClick() {
            this.$emit("iconClick");
        }
    }
};
</script>

<style lang="scss" scoped>
.delete-icon-wrapper {
    background-position: -4px -1px !important;

    &:hover {
        background-position: -252px -20px !important;
    }
}
</style>